module.exports = __webpack_public_path__ + "img/product28802b.df5d41ca.png";